// src/components/LanguageContext.js

import React, { createContext, useState } from 'react';
import srTranslations  from '../assets/translations/sr.json'; // Serbian translations
import enTranslations  from '../assets/translations/en.json'; // English translations
import slTranslations  from '../assets/translations/sl.json'; // Slovenian translations

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'sr');

    const switchLanguage = () => {
        let newLanguage;
        switch (language) {
            case 'sr':
                newLanguage = 'en';
                break;
            case 'en':
                newLanguage = 'sl';
                break;
            case 'sl':
                newLanguage = 'sr';
                break;
            default:
                newLanguage = 'sr';
        }
        setLanguage(newLanguage);
        localStorage.setItem('language', newLanguage);
    };

    const getTranslations = () => {
        switch (language) {
            case 'sr':
                return srTranslations;
            case 'en':
                return enTranslations;
            case 'sl':
                return slTranslations;
            default:
                return srTranslations;
        }
    };

    const translations = getTranslations();

    return (
        <LanguageContext.Provider value={{ switchLanguage, translations, language }}>
            {children}
        </LanguageContext.Provider>
    );
};
